module.exports = __webpack_public_path__ + "img/YouTube_logo.26a65798.png";